<template>
    <table class="table table-bordered table-striped table-vcenter dataTable">
        <thead>
            <tr>
                <th>Name</th>
                <th>Vehicles Count</th>
                <th></th>
            </tr>
        </thead>
        <tbody></tbody>
    </table>
</template>

<script>
export default {
    props: {
        ajaxUrl: String,
    },

    mounted() {
        window.jQuery(this.$el).dataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: this.ajaxUrl,
            },
            order: [[0, 'desc']],
            columns: [
                {
                    data: 'name',
                },
                {
                    data: 'vehicles_count',
                    searchable: false,
                    orderable: false,
                },
                {
                    data: 'actions',
                },
            ]
        });
    }
}
</script>
